import script from "./mobile-prototype-card-handle.vue?vue&type=script&setup=true&lang=ts"
export * from "./mobile-prototype-card-handle.vue?vue&type=script&setup=true&lang=ts"

import "./mobile-prototype-card-handle.vue?vue&type=style&index=0&id=4af72d90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af72d90"]])

export default __exports__